import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { IonicModule, ModalController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../../data.service';
import { DigitalisMunkarendModalComponent } from '../../naptar/digitalis-munkarend-modal/digitalis-munkarend-modal.component';

/**
 *  ADMIN → E-NAPLÓ → DIGITÁLIS MUNKAREND (backend: digitalis-munkarend.js).
 *
 *  Az elrendelt tantermen kívüli, digitális munkarend időszakai tanévenként: melyik osztályra,
 *  mettől meddig, ki rögzítette. Új időszak kézzel is felvehető (a tanév rendje szerinti
 *  időszakot a naptár beemelt bejegyzéséből érdemes indítani), és visszavonható.
 */
@Component({
  selector: 'app-admin-digitalis-munkarend',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './digitalis-munkarend.component.html',
  styleUrls: ['./digitalis-munkarend.component.scss'],
})
export class AdminDigitalisMunkarendComponent implements OnInit {
  intezmeny = '';
  tanev = new Date().getMonth() >= 7 ? new Date().getFullYear() : new Date().getFullYear() - 1;
  tanevek: number[] = [];
  idoszakok: any[] = [];
  szerkesztheto = false;
  toltodik = false;
  hiba = '';

  constructor(private http: HttpClient, private data: DataService, private modalCtrl: ModalController) {}

  async ngOnInit() {
    const si: any = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(si?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    this.tanevek = [this.tanev - 1, this.tanev, this.tanev + 1];
    await this.betolt();
  }

  async betolt() {
    if (!this.intezmeny) return;
    this.toltodik = true; this.hiba = '';
    try {
      const r: any = await firstValueFrom(this.http.get(
        `/api/digitalis-munkarend/lista/${encodeURI(this.intezmeny)}?tanev=${this.tanev}`));
      this.idoszakok = r?.idoszakok || [];
      this.szerkesztheto = !!r?.szerkesztheto;
    } catch (e: any) { this.hiba = e?.error?.error || 'Az időszakok nem tölthetők be.'; }
    this.toltodik = false;
  }

  osztalyNevek(x: any): string {
    return (x?.osztalyok || []).map((o: any) => o.nev).join(', ') || '—';
  }

  kor(x: any): string {
    const evf = (x?.evfolyamok || []).length ? `${x.evfolyamok.join('., ')}. évfolyam` : '';
    const db = (x?.osztaly_idk || []).length ? `${x.osztaly_idk.length} külön választott osztály` : '';
    return [evf, db].filter(Boolean).join(' + ');
  }

  async uj() {
    //  Kézi felvétel: alapból a mai nap, évfolyam nélkül (a modalban választható).
    const ma = new Date().toLocaleDateString('sv-SE');
    const m = await this.modalCtrl.create({
      component: DigitalisMunkarendModalComponent,
      componentProps: { intezmeny: this.intezmeny, tktId: null, tol: ma, ig: ma, evfolyamok: [] },
    });
    await m.present();
    await m.onDidDismiss();
    await this.betolt();
  }

  async torol(x: any) {
    if (!confirm(`Visszavonod a(z) ${x.tol} – ${x.ig} digitális munkarendet (${this.osztalyNevek(x)})?`)) return;
    try {
      await firstValueFrom(this.http.request('delete', `/api/digitalis-munkarend/tetel/${x.id}`,
        { params: { intezmeny: this.intezmeny } }));
      this.data.sendToast('Visszavonva.', 'success');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A visszavonás nem sikerült.', 'error');
    }
  }
}
